import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import css from "./DishRightBlockSingleNumberReusModal.module.css";

const OVERRIDE_FIELD_BY_FORM_FIELD = {
  Energy: "energyOverridden",
  Proteins: "proteinsOverridden",
  Fats: "fatsOverridden",
  Carbohydrates: "carbohydratesOverridden",
  Cost: "costOverridden",
};

const DishRightBlockSingleNumberReusModal = ({
  positionName,
  overrideLabel,
}) => {
  const { t } = useTranslation();

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const getFieldName = (translatedName) => {
    const fieldMapping = {
      [t("modal-energy")]: "Energy",
      [t("modal-proteins")]: "Proteins",
      [t("modal-fats")]: "Fats",
      [t("modal-carbohydrates")]: "Carbohydrates",
      [t("Cost")]: "Cost",
    };
    return fieldMapping[translatedName] || translatedName;
  };

  const fieldName = getFieldName(positionName);
  const overrideFieldName = OVERRIDE_FIELD_BY_FORM_FIELD[fieldName];
  const isOverridden = overrideFieldName ? watch(overrideFieldName) : false;

  return (
    <div className={css.wrap}>
      <div className={css.inputGroup}>
        <label htmlFor={fieldName} className={css.label}>
          {positionName}
        </label>
        <input
          type="number"
          id={fieldName}
          step="any"
          className={css.input}
          disabled={!isOverridden}
          {...register(fieldName, { valueAsNumber: true })}
        />

        {errors[fieldName] && (
          <p className={css.error}>{errors[fieldName].message}</p>
        )}
      </div>

      <div className={css.checkboxGroup}>
        <input
          type="checkbox"
          id={`${fieldName}-override`}
          className={css.checkbox}
          {...(overrideFieldName ? register(overrideFieldName) : {})}
        />

        <label htmlFor={`${fieldName}-override`} className={css.label}>
          {overrideLabel}
        </label>
      </div>
    </div>
  );
};

export { DishRightBlockSingleNumberReusModal };
